import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const Privacy = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Privacy", "terms/privacy_body_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.Privacy || { Main: {} };
  return (
    <div className="container py-5 text-start" style={{ lineHeight: "1.8em" }}>
      <h2 className="mb-4">{LANGUAGE.Main.Content1}</h2>

      <h4>{LANGUAGE.Main.Content2}</h4>
      <p>{LANGUAGE.Main.Content3}</p>
      <p>{LANGUAGE.Main.Content4}</p>
      <p>{LANGUAGE.Main.Content5}</p>

      <h4>{LANGUAGE.Main.Content6}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content7}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content8}</li>
            <li>{LANGUAGE.Main.Content9}</li>
            <li>{LANGUAGE.Main.Content10}</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content11}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content12}</li>
            <li>{LANGUAGE.Main.Content13}</li>
            <li>{LANGUAGE.Main.Content14}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content15}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content16}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content17}</li>
            <li>{LANGUAGE.Main.Content18}</li>
            <li>{LANGUAGE.Main.Content19}</li>
            <li>{LANGUAGE.Main.Content20}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content21}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content22}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content23}</li>
            <li>{LANGUAGE.Main.Content24}</li>
            <li>{LANGUAGE.Main.Content25}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content26}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content27}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content28}</li>
            <li>{LANGUAGE.Main.Content29}</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content30}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content31}</li>
            <li>{LANGUAGE.Main.Content32}</li>
            <li>{LANGUAGE.Main.Content33}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content34}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content35}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content36}</li>
            <li>{LANGUAGE.Main.Content37}</li>
            <li>{LANGUAGE.Main.Content38}</li>
            <li>{LANGUAGE.Main.Content39}</li>
            <li>{LANGUAGE.Main.Content40}</li>
          </ul>
          <p>{LANGUAGE.Main.Content41}</p>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content42}</h4>
      <ul>
        <li>
          <ul>
            <li>{LANGUAGE.Main.Content43}</li>
            <li>{LANGUAGE.Main.Content44}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content45}</h4>
      <ul>
        <li>
          <ul>
            <li>{LANGUAGE.Main.Content46}</li>
            <li>{LANGUAGE.Main.Content47}</li>
          </ul>
        </li>
      </ul>

      <hr className="my-4" />
      <h4>{LANGUAGE.Main.Content48}</h4>
      <p>
        <strong>{LANGUAGE.Main.Content49}</strong> {LANGUAGE.Main.Content50}
        <br />
        <strong>{LANGUAGE.Main.Content51}</strong>{" "}
        <a href={`mailto:${LANGUAGE.Main.Content52}`}>
          {LANGUAGE.Main.Content52}
        </a>
        <br />
        <strong>{LANGUAGE.Main.Content53}</strong>{" "}
        <a
          href={LANGUAGE.Main.Content54}
          target="_blank"
          rel="noopener noreferrer"
        >
          {LANGUAGE.Main.Content54}
        </a>
      </p>
    </div>
  );
};

export default Privacy;
